// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e19e45bd","453":"59a2a6ec","455":"6dabd74e","977":"0e9b325f"}[chunkId] + ".chunk.js";
};